import { useQuery } from '@tanstack/react-query';
import { api } from '../services/authService';

const useGetExchangeRate = (id: string | null) => {
  const {
    data,
    error,
    isLoading,
    isError,
    refetch,
    isPending,
  } = useQuery({
    queryKey: ['exchange-rate', id],
    queryFn: async () => {
      if (!id) throw new Error('Exchange rate ID is required');
      const response = await api.get(`/admin/rates/${id}`);
      return response.data;
    },
    enabled: !!id, // Only run query if id is provided
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  return {
    data,
    error,
    isLoading,
    isError,
    refetch,
    isPending,
  };
};

export default useGetExchangeRate; 